import React from 'react';
import { buildApplicationDocumentRowKey } from '~/modules/covenants/utils.ts';
import { DocTableRow } from '~/modules/covenants/CovenantsDataApplicationForm/components/DocTableRow.tsx';
import { TGroupedDocument } from '~/modules/covenants/CovenantsDataApplicationForm/hooks/useGroupedDocuments.ts';
import {
  getFileRowDividerVariant,
  getParentRowDividerVariant,
} from '~/modules/covenants/CovenantsDataApplicationForm/utils.ts';

interface IDocListGroupRowsProps {
  group: TGroupedDocument;
  isExpanded: boolean;
  isLastGroup: boolean;
  onToggleExpand: () => void;
}

export const DocListGroupRows: React.FC<IDocListGroupRowsProps> = ({
  group,
  isExpanded,
  isLastGroup,
  onToggleExpand,
}) => {
  const fileRowsCount = group.fileRows.length;
  const parentDividerVariant = getParentRowDividerVariant({
    isExpanded,
    fileRowsCount,
    isLastGroup,
  });

  return (
    <>
      <DocTableRow
        doc={group.primaryDoc}
        rowVariant="document"
        groupHasFiles={group.hasFiles}
        isExpanded={isExpanded}
        dividerVariant={parentDividerVariant}
        onToggleExpand={onToggleExpand}
        groupedStatus={group.aggregatedStatus}
      />

      {isExpanded &&
        group.fileRows.map((doc, index) => (
          <DocTableRow
            key={buildApplicationDocumentRowKey(doc)}
            doc={doc}
            rowVariant="file"
            groupHasFiles={group.hasFiles}
            isExpanded={isExpanded}
            dividerVariant={getFileRowDividerVariant({
              fileIndex: index,
              fileRowsCount,
              isLastGroup,
            })}
          />
        ))}
    </>
  );
};
